import dynamic from 'next/dynamic'

export const DynamicRetailerSelectionDrawer = dynamic(
  () =>
    import('@/features/cms/components/CMS/components/RetailerSelectionDrawer').then(
      (mod) => mod.RetailerSelectionDrawer,
    ),
  { ssr: false },
)
